import React from 'react'
import errorImage from '../images/user/error.png'

const Error = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Oops! Something went wrong.</h1>
      <p>We can't find the page you're looking for.</p>
      <img src={errorImage} alt="Error" style={{ width: '450px', height: 'auto' }}/>
    </div>
  )
}

export default Error